module.exports = __webpack_public_path__ + "static/pointing-5929ad931cae3cde73eb64ffaa3ff691.png";